(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cp-availability"] && !Shopify.designMode) return;
  try {
    /* CP-107: Klaviyo back-in-stock sign-up for the sold-out notify form.
     Delegated, so it also covers a form that appears after a variant switch.
     Falls back to the plain contact form submit on any failure. */
  (() => {
    if (window.__cpBis) return;
    window.__cpBis = true;
    document.addEventListener(
      'submit',
      async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-cp-bis')) return;
        if (form.dataset.cpBisFallback === '1') return;
        const input = form.querySelector('input[type="email"]');
        const email = (input && input.value || '').trim();
        const variant = form.dataset.cpBisVariant;
        const company = form.dataset.cpBisCompany;
        if (!email || !variant || !company) return;
        event.preventDefault();
        event.stopPropagation();
        const button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
        try {
          const response = await fetch(
            'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(company),
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
              body: JSON.stringify({
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    channels: ['EMAIL'],
                    profile: { data: { type: 'profile', attributes: { email } } },
                  },
                  relationships: {
                    variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } },
                  },
                },
              }),
            }
          );
          if (!response.ok) throw new Error('klaviyo ' + response.status);
          const done = document.createElement('p');
          done.className = 'cp-notify__done';
          done.setAttribute('role', 'status');
          done.textContent = form.dataset.cpBisThanks || '';
          form.replaceChildren(done);
          document.dispatchEvent(new CustomEvent('cp:back-in-stock', { detail: { variant } }));
        } catch (error) {
          form.dataset.cpBisFallback = '1';
          if (button) button.disabled = false;
          form.submit();
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
